import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter, defineMessage, defineTopic } from 'magpie-lib/models';
export const closeModal = defineMessage({
  type: 'CLOSE_MODAL'
});
export const ConnectionSettingsModalIFrameTopic = defineTopic({
  name: '@connections-embed/CONNECTION_SETTINGS_MODAL_IFRAME',
  messages: [closeModal],
  enableRuntimeValidation: false,
  audience: AudienceFilter.builder().build()
});
export function publishCloseModal() {
  MagpieConnection.get().forTopic(ConnectionSettingsModalIFrameTopic).publish(closeModal.create());
}